<div class="templateBody">
  <p class="link">Manage Users</p>

  <div *ngIf="canAddUser">
    <a class="btn btn-primary" style="margin-top:10px; margin-bottom:10px;" [routerLink]="['/user']" role="menuitem">Add
      New User</a>
  </div>
    
  <p-table #tt [columns]="cols" [value]="users" [paginator]="true" [rows]="rowCount" [rowHover]="true" styleClass="p-datatable-sm p-datatable-gridlines custom-table">
    <ng-template pTemplate="caption">
      <div class="table-toolbar">
        <div class="left">
          Show
          <p-select [options]="entries" [(ngModel)]="selectedEntry" optionLabel="val" (onChange)="updateRowCount($event)" [style]="{ width: '50px'}"></p-select>
          users
        </div>
        <div class="right">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="pi pi-search"></i>
            </span>
            <input pInputText placeholder="   Search" (input)="tt.filterGlobal($event.target.value,'contains')">
          </div>
        </div>
      </div>
    </ng-template>
      
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="text-align:center" [ngStyle]="{'width':col.width}" *ngFor="let col of columns"
          [pSortableColumn]="col.field" pResizableColumn>
          {{col.header}}
          <p-sortIcon [field]="col.field" style="display:block;margin:0 5px 0 0"></p-sortIcon>
          <div *ngIf="col.isServiceCenter">
             <div class="p-d-flex p-jc-between p-ai-center">
               <p-columnFilter [field]="col.field" matchMode="equals" display="menu">
                 <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                   <p-select [ngModel]="value" [options]="centerLabels" (onChange)="filter($event.value)"
                     placeholder="Any" [showClear]="true">
                     <ng-template let-option pTemplate="item">
                       <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                     </ng-template>
                   </p-select>
                 </ng-template>
               </p-columnFilter>
             </div>
          </div>
          <div *ngIf="col.isActive">
            <div class="p-d-flex p-jc-between p-ai-center">
              <p-columnFilter [field]="col.field" matchMode="equals" display="menu">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-select [ngModel]="value" [options]="activeLabels" (onChange)="filter($event.value)"
                    placeholder="Any" [showClear]="true">
                    <ng-template let-option pTemplate="item">
                      <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                    </ng-template>
                  </p-select>
                </ng-template>
              </p-columnFilter>
            </div>
         </div>  
         <div *ngIf="col.isRole">
          <div class="p-d-flex p-jc-between p-ai-center">
            <p-columnFilter [field]="col.field" matchMode="equals" display="menu">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-select [ngModel]="value" [options]="roleLabels" (onChange)="filter($event.value)"
                  placeholder="Any" [showClear]="true">
                  <ng-template let-option pTemplate="item">
                    <span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
                  </ng-template>
                </p-select>
              </ng-template>
            </p-columnFilter>
          </div>
       </div>                  
        </th>
        <th style="text-align:center; width:6%">Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-user let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" style="overflow: hidden;">
          {{user[col.field]}}
        </td>
        <td>
          <a class="block" [routerLink]="['/user', user.userId]">Edit</a>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="isPortalAdmin">
    <p class="link" style="margin-top:50px;display: block">Manage NFDC Airport Data</p>
    <p style="margin-bottom: 10px">Last NFDC airport update: {{lastUpdate | date:'EEE, y-MM-dd HH:mm' | mt}}</p>
    <form [formGroup]="nfdcForm" novalidate (ngSubmit)="onSubmit()">
      <!-- service center -->
      <div class="form-group">
        <label class="inc-top">Enable or disable automated updated?</label>
        <div class="radio reduce-top">
          <label>
            <input type="radio" name="enableNfdc" value="enable" formControlName="enableNfdc">Enable
          </label>
        </div>
        <div class="radio">
          <label>
            <input type="radio" name="enableNfdc" value="disable" formControlName="enableNfdc">Disable
          </label>
        </div>
      </div>
    </form>

    <div style="margin-bottom: 10px">
      <button class="btn btn-primary" [disabled]="disableSave" (click)="onSubmit()">Save</button>
    </div>
    <div style="margin-bottom: 20px">
      <button class="btn btn-primary" [disabled]="disableNfdc" (click)="runNfdc()">Run NFDC Airport data import</button>
    </div>
    <div style="margin-bottom: 20px">
      <button class="btn btn-primary" [disabled]="disableNfdc" (click)="runNfdcNavaids()">Run NFDC Navigation Aids data import</button>
    </div>
    <!-- <div style="margin-bottom: 20px">
      <button class="btn btn-primary" [disabled]="disableNfdc" (click)="runNfdcAirways()">Run NFDC Airways data import</button>
    </div> -->

    <!-- <div style="margin-bottom: 20px">
      <button class="btn btn-primary" (click)="evalSubmission()">Evaluate Submissions</button>
    </div> -->
  </div>
</div>